// extracted by mini-css-extract-plugin
module.exports = {"TotalPrice":"TotalPrice_TotalPrice__43jeo"};